'use strict'

module.exports = {
    videoPosterPrefix: 'addPanelData/sections/videos_en/gridGalleries/v1/gallery-video-thumb-more-',
    videoSrcPrefix: 'v1/gallery-video-thumb-more-'
}